module.exports = __webpack_public_path__ + "static/img/ios.e6e8158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/th/ios.png
// module id = +85N
// module chunks = 1